/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { CopyRule } from './CopyRule';
import {
    CopyRuleFromJSON,
    CopyRuleFromJSONTyped,
    CopyRuleToJSON,
    CopyRuleToJSONTyped,
} from './CopyRule';
import type { PriceStatus } from './PriceStatus';
import {
    PriceStatusFromJSON,
    PriceStatusFromJSONTyped,
    PriceStatusToJSON,
    PriceStatusToJSONTyped,
} from './PriceStatus';
import type { FilterMode } from './FilterMode';
import {
    FilterModeFromJSON,
    FilterModeFromJSONTyped,
    FilterModeToJSON,
    FilterModeToJSONTyped,
} from './FilterMode';
import type { LaunchStatusHy } from './LaunchStatusHy';
import {
    LaunchStatusHyFromJSON,
    LaunchStatusHyFromJSONTyped,
    LaunchStatusHyToJSON,
    LaunchStatusHyToJSONTyped,
} from './LaunchStatusHy';

/**
 * 
 * @export
 * @interface CopyPriceRequest
 */
export interface CopyPriceRequest {
    /**
     * 
     * @type {Date}
     * @memberof CopyPriceRequest
     */
    validFromDate: Date;
    /**
     * 
     * @type {number}
     * @memberof CopyPriceRequest
     */
    copyFromPriceUnitId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CopyPriceRequest
     */
    copyToPriceUnitIds: Array<number>;
    /**
     * 
     * @type {Array<PriceStatus>}
     * @memberof CopyPriceRequest
     */
    copyFromPriceStatuses: Array<PriceStatus>;
    /**
     * 
     * @type {Array<PriceStatus>}
     * @memberof CopyPriceRequest
     */
    copyToPriceStatuses: Array<PriceStatus>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CopyPriceRequest
     */
    themeIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyPriceRequest
     */
    themeIdsAsString?: Array<string> | null;
    /**
     * 
     * @type {FilterMode}
     * @memberof CopyPriceRequest
     */
    themeFilterMode?: FilterMode;
    /**
     * 
     * @type {Array<number>}
     * @memberof CopyPriceRequest
     */
    groupIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyPriceRequest
     */
    groupIdsAsString?: Array<string> | null;
    /**
     * 
     * @type {FilterMode}
     * @memberof CopyPriceRequest
     */
    groupFilterMode?: FilterMode;
    /**
     * 
     * @type {Array<number>}
     * @memberof CopyPriceRequest
     */
    productIds?: Array<number> | null;
    /**
     * 
     * @type {FilterMode}
     * @memberof CopyPriceRequest
     */
    productFilterMode?: FilterMode;
    /**
     * 
     * @type {Array<LaunchStatusHy>}
     * @memberof CopyPriceRequest
     */
    productStatuses?: Array<LaunchStatusHy> | null;
    /**
     * 
     * @type {CopyRule}
     * @memberof CopyPriceRequest
     */
    copyRule: CopyRule;
}



/**
 * Check if a given object implements the CopyPriceRequest interface.
 */
export function instanceOfCopyPriceRequest(value: object): value is CopyPriceRequest {
    if (!('validFromDate' in value) || value['validFromDate'] === undefined) return false;
    if (!('copyFromPriceUnitId' in value) || value['copyFromPriceUnitId'] === undefined) return false;
    if (!('copyToPriceUnitIds' in value) || value['copyToPriceUnitIds'] === undefined) return false;
    if (!('copyFromPriceStatuses' in value) || value['copyFromPriceStatuses'] === undefined) return false;
    if (!('copyToPriceStatuses' in value) || value['copyToPriceStatuses'] === undefined) return false;
    if (!('copyRule' in value) || value['copyRule'] === undefined) return false;
    return true;
}

export function CopyPriceRequestFromJSON(json: any): CopyPriceRequest {
    return CopyPriceRequestFromJSONTyped(json, false);
}

export function CopyPriceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyPriceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'validFromDate': (new Date(json['validFromDate'])),
        'copyFromPriceUnitId': json['copyFromPriceUnitId'],
        'copyToPriceUnitIds': json['copyToPriceUnitIds'],
        'copyFromPriceStatuses': ((json['copyFromPriceStatuses'] as Array<any>).map(PriceStatusFromJSON)),
        'copyToPriceStatuses': ((json['copyToPriceStatuses'] as Array<any>).map(PriceStatusFromJSON)),
        'themeIds': json['themeIds'] == null ? undefined : json['themeIds'],
        'themeIdsAsString': json['themeIdsAsString'] == null ? undefined : json['themeIdsAsString'],
        'themeFilterMode': json['themeFilterMode'] == null ? undefined : FilterModeFromJSON(json['themeFilterMode']),
        'groupIds': json['groupIds'] == null ? undefined : json['groupIds'],
        'groupIdsAsString': json['groupIdsAsString'] == null ? undefined : json['groupIdsAsString'],
        'groupFilterMode': json['groupFilterMode'] == null ? undefined : FilterModeFromJSON(json['groupFilterMode']),
        'productIds': json['productIds'] == null ? undefined : json['productIds'],
        'productFilterMode': json['productFilterMode'] == null ? undefined : FilterModeFromJSON(json['productFilterMode']),
        'productStatuses': json['productStatuses'] == null ? undefined : ((json['productStatuses'] as Array<any>).map(LaunchStatusHyFromJSON)),
        'copyRule': CopyRuleFromJSON(json['copyRule']),
    };
}

export function CopyPriceRequestToJSON(json: any): CopyPriceRequest {
    return CopyPriceRequestToJSONTyped(json, false);
}

export function CopyPriceRequestToJSONTyped(value?: CopyPriceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'validFromDate': (formatDateOnly(value['validFromDate'])),
        'copyFromPriceUnitId': value['copyFromPriceUnitId'],
        'copyToPriceUnitIds': value['copyToPriceUnitIds'],
        'copyFromPriceStatuses': ((value['copyFromPriceStatuses'] as Array<any>).map(PriceStatusToJSON)),
        'copyToPriceStatuses': ((value['copyToPriceStatuses'] as Array<any>).map(PriceStatusToJSON)),
        'themeIds': value['themeIds'],
        'themeIdsAsString': value['themeIdsAsString'],
        'themeFilterMode': FilterModeToJSON(value['themeFilterMode']),
        'groupIds': value['groupIds'],
        'groupIdsAsString': value['groupIdsAsString'],
        'groupFilterMode': FilterModeToJSON(value['groupFilterMode']),
        'productIds': value['productIds'],
        'productFilterMode': FilterModeToJSON(value['productFilterMode']),
        'productStatuses': value['productStatuses'] == null ? undefined : ((value['productStatuses'] as Array<any>).map(LaunchStatusHyToJSON)),
        'copyRule': CopyRuleToJSON(value['copyRule']),
    };
}

